import React from 'react';
import type { YesNo as YesNoValue } from '../../types/application';
interface YesNoProps {
  value: YesNoValue;
  onChange: (v: YesNoValue) => void;
  label: string;
}
export function YesNo({
  value,
  onChange,
  label
}: YesNoProps) {
  return <div role="radiogroup" aria-label={label} className="grid w-full grid-cols-2 gap-2 md:w-48" data-id="element-723" data-mp="2oc08ugvvj3cf">
      {(['no', 'yes'] as const).map(v => {
      const active = value === v;
      return <button key={v} type="button" role="radio" aria-checked={active} onClick={() => onChange(v)} className={`h-11 rounded-xl text-sm font-medium ring-1 ring-inset transition-[background-color,color,box-shadow] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500 ${active ? 'bg-ink-900 text-white ring-ink-900' : 'bg-white text-ink-700 ring-ink-200 hover:ring-ink-300'}`} data-id="element-724" data-mp="2yb90h339o5vm">
            {v === 'yes' ? 'Yes' : 'No'}
          </button>;
    })}
    </div>;
}